import { graphConfig } from "./authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
 export async function getMyDirectReports(accessToken, skipToken='', filter='') {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(`${graphConfig.graphDirectReportsEndpoint}${skipToken ? `&loadMoreLink=${skipToken}` : ''}${filter ? `&filterUsersName=${filter}` : ''}`, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
 export async function getMyRecruitmentRequests(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(`${graphConfig.graphRecruitmentRequestsEndpoint}`, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 * @param userId
 */
 export async function offBoardUser(accessToken, userId, leavingDate, leavingReason) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify({
            "exts5qeux5w_WiderTeam": {
                "terminationDate": leavingDate,
                "terminationReasonDescription": leavingReason
            }
        })
    };

    return new Promise((resolve, reject) => fetch(`${graphConfig.graphUpdateUserEndpoint.replace('USERID', userId)}`, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve();
            }
        }).catch(error => reject(error))
    );
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 * @param userId
 */
 export async function updateUserAPI(accessToken, userId, userData) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(userData)
    };

    return new Promise((resolve, reject) => fetch(`${graphConfig.graphUpdateUserEndpoint.replace('USERID', userId)}`, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve();
            }
        }).catch(error => reject(error))
    );
}

/**
 * Attaches a given access token to a MS Graph API call. Creates recruitment request
 * @param accessToken 
 * @param userId
 */
 export async function createRequestAPI(accessToken, requestData) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestData)
    };

    return new Promise((resolve, reject) => fetch(graphConfig.graphRecruitmentRequestsCreateEndpoint, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve();
            }
        }).catch(error => reject(error))
    );
}

/**
 * Attaches a given access token to a MS Graph API call. Creates recruitment request
 * @param accessToken 
 * @param userId
 */
 export async function updateNewStarterAPI(accessToken, userData) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(userData)
    };

    return new Promise((resolve, reject) => fetch(`${graphConfig.graphNewStarterEndpoint.replace('RECRUITMENTID', userData.id)}`, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve();
            }
        }).catch(error => reject(error))
    );
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 * @param userId
 */
 export async function downloadExportFile(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        headers: headers,
    };

    return fetch(`${graphConfig.downloadAADInfoEndpoint}`, options)
        .catch(error => console.log(error));
}

/**
 * Attaches a given access token to a MS Graph API call. Returns information about users matching input
 * @param accessToken 
 * @param userId
 */
 export async function searchUsers(accessToken, searchValue) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "GET",
        headers: headers,
    };

    return new Promise((resolve, reject) => fetch(`${graphConfig.graphGetUsersEndpoint}&filterUsersName=${searchValue}`, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve(response.json());
            }
        }).catch(error => reject(error))
    );
};

/**
 * Attaches a given access token to a MS Graph API call. Returns information about positions matching input
 * @param accessToken 
 * @param userId
 */
 export async function searchPositions(accessToken, searchValue) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "GET",
        headers: headers,
    };

    return new Promise((resolve, reject) => fetch(`${graphConfig.graphGetPositionsEndpoint}&filterPosition=${searchValue}`, options)
        .then((response) => {
            if (response.status !== 200) {
                response.text().then((errorMessage) => reject(errorMessage));
            } else {
                resolve(response.json());
            }
        }).catch(error => reject(error))
    );
};
